import React from 'react';

import EmergencyAccess from '@views/Settings/EmergencyAccess';

export default function EmergencyAccessPage() {
  return <EmergencyAccess />;
}
